import { render, staticRenderFns } from "./BosAdminStepForm.vue?vue&type=template&id=51c4455a&scoped=true"
import script from "./BosAdminStepForm.vue?vue&type=script&lang=js"
export * from "./BosAdminStepForm.vue?vue&type=script&lang=js"
import style0 from "./BosAdminStepForm.vue?vue&type=style&index=0&id=51c4455a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4455a",
  null
  
)

export default component.exports